module.exports = __webpack_public_path__ + "img/thirteen.dd37600f.png";